import { Outlet } from "react-router-dom";
import Header from "../../../components/header/Header.jsx";
import ManagerSidebar from "../../sidebar/managerSidebar/ManagerSidebar.jsx";

export function ManagerLayout(){
    return (
        <div>
            <Header title='Wisdom Dashboard'/>
            <div className="layout-container">
                <ManagerSidebar />
                <div className="layout-outlet">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}